// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2MBZN","errorLogs":"styles_errorLogs__3DWtC"};